import React, { useEffect, useState } from 'react'
import { View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux';
import { getAddonsForSpa, getMySpaBooking, getSpaTreatmentList, makeSpaBooking, searchSpaAvailability, updateMySpaBooking } from '../../Redux/Actions/spaBookingAction';
import InfoPopupModal from '../../components/infoPopupModal';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';

import SpaBooking0 from './spaBooking0';
import SpaBooking1 from './spaBooking1';
import SpaBooking1a from './spaBooking1a';
import SpaBooking2a from './spaBooking2a';
import SpaBooking2b from './spaBooking2b';
import SpaBooking2c from './spaBooking2c';
import SpaBookingSummary from './spaBookingSummary';
import SpaBookingSuccess from './spaBookingSuccess';
import { useTranslation } from 'react-i18next';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { calculateTimeDifference, generateToken } from '../../utils/Helper';
import { CLICKED, EXIT, INITIAL_LOADER_SCREEN, SPA_BOOKING_CATEGORY } from '../../config/Constant';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';

const Book4Time = () => {
    const dispatch = useDispatch();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { isLoggedIn } = useSelector(state => state.appConfigSlice);
    const { spaBookingData } = useSelector(state => state.spaBookingSlice);

    const { t } = useTranslation();

    let widgetLaunchTime = new Date;

    const spaSessionToken = generateToken("spa_")

    const [bookingObj, setBookingObj] = useState({
        additionalDetails: {
            "email": "",
            "mobileNumber": "",
            "guestNotes": ""
        }
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [loaderState, setLoaderState] = useState({
        showLoader: "",
        loaderMessage: ""
    });
     const [initialLoading, setInitialLoading] = useState(true);

    const [fetchApiError, setFetchApiError] = useState({
        errorStatus: false,
        errorMessage: "",
        onContinueFunc: null,
        primaryBtnLabel: "",
        onCloseFunc: null,
        secondaryBtnLabel: ""
    });

    const [infoPopup, setInfoPopup] = useState({
        visible: false,
        title: '',
        subtitle: '',
        primaryBtnLabel: "",
        onContinue: null,
        secondaryBtnLabel: "",
        onClose: null
    })

    const updateFetchApiError = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel) => {
        setFetchApiError({
            errorStatus,
            errorMessage: errorStatus ? errorMessage : "",
            onContinueFunc: errorStatus ? onContinueFunc : null,
            primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
            onCloseFunc: errorStatus ? onCloseFunc : null,
            secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
        });
    }

    const updateInfoPopup = (visible, title, subtitle, primaryBtnLabel, onContinue, secondaryBtnLabel, onClose) => {
        setInfoPopup({
            visible,
            title: visible ? title : "",
            subtitle: visible ? subtitle : "",
            primaryBtnLabel: visible ? primaryBtnLabel : "",
            onContinue: visible ? onContinue : null,
            secondaryBtnLabel: visible ? secondaryBtnLabel : "",
            onClose: visible ? onClose : null
        })
    }

    const updateLoaderState = (loading, message) => {
        setLoaderState({
            showLoader: loading,
            loaderMessage: message
        })
    }

    const updateBookingObj = (obj = {}, callback) => {
        setBookingObj(prev => {
            const newObj = { ...prev, ...obj };
            if (callback) callback(newObj);
            return newObj;
        });
    };


    const spaTreatmentListCallback = (status, data) => {
        // updateLoaderState(false)
        setInitialLoading(false)

        if(!status){
            updateFetchApiError(true, data, handleGoBack);
            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA DATA - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: data }));
            return
        }

        let charges_details= { serviceCharge: 0, tax: 0 };
        
        if(data.serviceCharge) charges_details.serviceCharge= data.serviceCharge ;
        if(data.tax) charges_details.tax= data.tax ;
        
        updateBookingObj({ 
            spa_data: data,
            chargesDetails: charges_details
        }, () => {
            setCurrentPage(0);
        })
        
        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA DATA - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage }));
    }


    const fetctSpaTreatmentList = async () => {
        // updateLoaderState(true, "Fetching locations...");
        if(spaBookingData){
            spaTreatmentListCallback(true, spaBookingData);
            return
        }

        setInitialLoading(true)
        try {

            await dispatch(getSpaTreatmentList(currentWidget?.spaLocationId, spaTreatmentListCallback));
        } catch (error) {
            console.log(error);
            updateFetchApiError(true, error?.message);
        } finally {
            // updateLoaderState(false)
            // setInitialLoading(false)
        }
    }

    const handleLocationNextScreen1 = (spaLocationId) => {
        let serviceGroupData
        bookingObj.spa_data?.forEach((data) => {
            if (data.spalocationId == spaLocationId) {
                serviceGroupData = data?.serviceGroup;
            }
        });

        updateBookingObj({ 
            spaLocationId,
            serviceGroupData
        })
    };

    const getSpaDetailsCallback = (status, data) => {
        updateLoaderState(false)

        if(!status){
            updateFetchApiError(true, data);

            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA MY RESERVATION - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: data }));
            return
        }

        let spaReservations = data.filter((r) => r.type == "spa");

        let locationWiseReservations ={};

        bookingObj?.spa_data?.forEach((data)=>{
            locationWiseReservations[`my_reservations_${data.spalocationId}`]=[];
        })


        spaReservations.forEach((reservation) => {
            const key = `my_reservations_${reservation.locationId}`;

            if (locationWiseReservations.hasOwnProperty(key)) {
                locationWiseReservations[key] = [...locationWiseReservations[key], reservation];
            } else {
                locationWiseReservations[key] = [reservation]
            }
        })

        const reservationsParticularToSpaLocation = spaReservations.filter(d => { return d.locationId == bookingObj?.spaLocationId })

        updateBookingObj({ 
            myExistingReservation: reservationsParticularToSpaLocation,
            cachedApiDataStore: locationWiseReservations,
            isAnyPrevReservForAnyLocation: spaReservations.length > 0
         })

        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA MY RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage }));
    }

    const getExistingReservations = ()=>{
        if (bookingObj?.cachedApiDataStore?.hasOwnProperty(`my_reservations_${bookingObj?.spaLocationId}`)) {
            updateBookingObj({ myExistingReservation: bookingObj?.cachedApiDataStore[`my_reservations_${bookingObj?.spaLocationId}`] })
        } else {
            // Need to be checked
            updateLoaderState(true, "Fetching booking details...")
            const payload= {};
            dispatch(getMySpaBooking(payload, getSpaDetailsCallback))
        }
    }

    const shouldProceedOnDeprecatedAddonsWarning = (shouldProceed) => {
        updateBookingObj({
            selectedService: shouldProceed ? bookingObj?.selectedService : null,
            showDeprecatedAddonWarning: false,
            deprecatedAddonList: null,
        })

        if (shouldProceed) {
            setCurrentPage(3)
        }
    }

    const handleReservationUpdateNextToScreen4 = (reservationDetails) => {
        updateBookingObj({
            reservationDetails: reservationDetails,
        })

        let selectedService_ = {};
        const { serviceGroup } = bookingObj?.spa_data?.find(d => d.spalocationId == bookingObj?.spaLocationId);
        console.log(bookingObj?.spaLocationId)
        console.log(serviceGroup);

        console.log("reservationDetails", reservationDetails)
        for (let index = 0; index < serviceGroup.length; index++) {
            const services = serviceGroup[index];
            const service = services.services?.find(service => service.id == reservationDetails.lines[0].serviceId)

            if (service) {
                selectedService_['name'] = services.name;
                selectedService_['service'] = service;
                break;

            }
        }


        if (Object.keys(selectedService_).length == 0) {
            // props.closeOrderPopUp(true, t('spaBooking.No_record_found'), "", true);

            updateFetchApiError(true, t('spaBooking.No_record_found'))

            return
        }

        
        
        const fetchAddonServiceCallback = (status, availableAddon_) => {
            updateLoaderState(false);

            if(!status){
                updateFetchApiError(true, availableAddon_);
                dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA SERVICE ADDONS - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: availableAddon_ }));
                return;
            }

            const hasDeprecatedAddons = ifAnyDeprecatedAddon(
                availableAddon_,
                reservationDetails.lines[0].addOn
            );

            console.log("Available addons: ", availableAddon_)

            updateBookingObj({
                availableAddOns: availableAddon_,
                selectedService: selectedService_,
                showDeprecatedAddonWarning: hasDeprecatedAddons ? true : bookingObj?.showDeprecatedAddonWarning,
            });

            if(!hasDeprecatedAddons){
                setCurrentPage(3);
            }

            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA SERVICE ADDONS - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage}));
        }

        updateLoaderState(true)
        try {
            const payload={
                spaLocationId: Number(bookingObj?.spaLocationId),
                primaryServiceId: selectedService_.service.id, 
            }

            dispatch(getAddonsForSpa(payload, fetchAddonServiceCallback))
        } catch (error) {
            console.log(error)
            updateFetchApiError(true, error?.message);
        }

        // setCurrentPage(2)
    }

    const ifAnyDeprecatedAddon = (currentlyAvailableAddons, earlierSelectedAddons) => {
        if(!earlierSelectedAddons){
            earlierSelectedAddons=[]
        }
        let selectedAddons_=[];
        let unMatchedAddons_=[];
        for( let addon of earlierSelectedAddons){
            const matchingAddon = currentlyAvailableAddons.find(addon_=> (addon_.id == addon.serviceId) && (addon_.price == addon.price))
            
            if(matchingAddon){
                selectedAddons_.push(matchingAddon)
            }else{
                unMatchedAddons_.push(addon);
            }
        }

        updateBookingObj({
            selectedAddon: selectedAddons_,
            deprecatedAddonList: unMatchedAddons_.length > 0 ? unMatchedAddons_ : null
        })

        return unMatchedAddons_.length > 0;
    }

    const handleServiceNextScreen3 = (selectedDetails) => {
        const fetchAddonServiceCallback = (status, data) => {
            updateLoaderState(false);

            if(!status){
                updateFetchApiError(true, data);
                updateBookingObj({
                    selectedService: selectedDetails
                })

                return;
            }

            const hasDeprecatedAddons = ifAnyDeprecatedAddon(data, bookingObj?.reservationDetails?.lines[0].addOn)

            updateBookingObj({
                availableAddOns: data,
                selectedService: selectedDetails,
                showDeprecatedAddonWarning: hasDeprecatedAddons ? true : bookingObj?.showDeprecatedAddonWarning,
            });

            if(!hasDeprecatedAddons){
                setCurrentPage(3);
            }
        }
        
        updateLoaderState(true)
        try {
            const payload={
                spaLocationId: Number(bookingObj?.spaLocationId),
                primaryServiceId: selectedDetails.service.id, 
            }

            dispatch(getAddonsForSpa(payload, fetchAddonServiceCallback))
        } catch (error) {
            console.log(error)
            updateFetchApiError(true, error?.message);
        }
    };


    const restartSpaBookingFlow = () => {
        let cachedData = bookingObj?.cachedApiDataStore;
        const  key = `my_reservations_${bookingObj?.spaLocationId}`;
        delete cachedData[key];
        // setCachedApiDataStore(cachedData);

        setBookingObj(props => ({
            ...props,
            additionalDetails: {
                "email": "",
                "mobileNumber": "",
                "guestNotes": ""
            },
            cachedApiDataStore: cachedData,
            serviceGroupData: [],
            selectedService: null,
            successResponse: null,
            updateReservationDetails: null,
            selectedAddon: null,
            availableAddOns: null,
            duration: null,
            guestNotes: null,
            mobileNumber: null,
            spaServicePrice: null,
            spaTechnicianPrice: null,
            technicianId: null,
            // email: null
        }));

        console.log("Called", bookingObj)
         
        if (bookingObj?.spaLocationId){
            // handleLocationNextScreen1(bookingObj?.spaLocationId)
            setCurrentPage(0)
        } else {
            fetctSpaTreatmentList();
            setCurrentPage(-1);
        }
    }

    const searchSpaAvailabilityCallback = (status, data) => {
        updateLoaderState(false);
        if(!status){
            updateFetchApiError(true, data);

            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA TECHNICIAN - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: data}));
            return;
        }

        let technicianAvailableData = data.reduce((acc, curr) => {
            curr.availabilityData.forEach((d) => {
                acc.push(d);
            });
            return acc;
        }, [])
        updateBookingObj({
            technicianAvailableData: technicianAvailableData
        })

        setCurrentPage(4);

        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "FETCH SPA TECHNICIAN - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage}));
    }

    const handleSelectServiceDetailsNext = (selectedServiceDetails) => {
        updateLoaderState(true, "Fetching availability...");

        updateBookingObj({
            preferences: { 
                dateTime: selectedServiceDetails.dateTime, 
                gender: selectedServiceDetails.requestedType
            }
        })

        let searchAvailabilityPayload = {
            serviceType: "spa",
            dateTime: selectedServiceDetails.dateTime,
            serviceId: [bookingObj?.selectedService?.service.id],
            spaLocationId: bookingObj?.spaLocationId,
            requestedType: selectedServiceDetails.requestedType,
        };

        // try {
            dispatch(searchSpaAvailability(searchAvailabilityPayload, searchSpaAvailabilityCallback))
        // } catch (error) {
        //     console.log(error);
        //     // updateFetchApiError(true, error?.message)
        // }

    };

    const makeReservationCallback = (status, data) => {
        updateLoaderState(false)
        if(!status){
            updateFetchApiError(true, data);
            
            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "Make SPA RESERVATION - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: data}));
            return
        }


        updateBookingObj({
            successResponse: data
        })
        setCurrentPage(7);

        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "Make SPA RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage}));
    }

    const handleMakeReservation = (payload) => {
        updateLoaderState(true, "Making reservation...")
        try {
            dispatch(makeSpaBooking(payload, makeReservationCallback));
        } catch (error) {
            console.log(error);
            updateFetchApiError(true, error?.message)
        }
    }

    const updateReservationCallback = (status, data) => {
        updateLoaderState(false)
        if(!status){
            updateFetchApiError(true, data);

            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "UPDATE SPA RESERVATION - ERROR", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage, errorMessage: data}));

            return
        }

        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, "UPDATE SPA RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": spaSessionToken, "pageName": currentPage}));

        updateInfoPopup(true, t('spaBooking.success.thank_you'), t('spaBooking.success.successful_res_update'))
        
        restartSpaBookingFlow();
    }


    const handleUpdateReservation = (payload) => {
        updateLoaderState(true, "Updating reservation...")
        try {
            dispatch(updateMySpaBooking(payload, updateReservationCallback))
        } catch (error) {
            console.log(error);
            updateFetchApiError(true, error?.message)
        }
    }




    // console.log("Current page: ",currentPage, " Booking Object: ", bookingObj)
    
    const getCurrentPage = () => {
        switch(currentPage) {
            case 0:
                return (
                    <SpaBooking0 
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        updateBookingObj={updateBookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                );
            case 1:
                return (
                    <SpaBooking1
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        updateBookingObj={updateBookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}

                        shouldProceedOnDeprecatedAddonsWarning={shouldProceedOnDeprecatedAddonsWarning}
                        getExistingReservations={getExistingReservations}
                    />
                )
            case 2:
                return (
                    <SpaBooking1a 
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}

                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                )
            case 3:
                return (
                    <SpaBooking2a 
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        updateBookingObj={updateBookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                        updateFetchApiError={updateFetchApiError} 
                    />
                )
            case 4:
                return (
                    <SpaBooking2b 
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        updateBookingObj={updateBookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                )
            case 5:
                return (
                    <SpaBooking2c 
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        updateBookingObj={updateBookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                )
            case 6:
                return (
                    <SpaBookingSummary
                        currentWidget={currentWidget}
                        bookingObj={bookingObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}

                    />
                )
            case 7:
                return (
                    <SpaBookingSuccess
                        currentWidget={currentWidget}
                        selectedService={bookingObj?.selectedService}
                        successResponse={bookingObj?.successResponse}
                        updateReservationDetails={bookingObj?.updateReservationDetails}
                        handleNext={handleGoBack}
                    />
                )
            default:
                return <></>
        }
    }



    const handleNext = (data) => {
        switch(currentPage){
            case 0:
                handleLocationNextScreen1(data);
                setCurrentPage(1);
                return
            case 1:
                if(!data) {
                    setCurrentPage(2);
                    return
                }
                handleReservationUpdateNextToScreen4(data)
                return
            case 2:
                handleServiceNextScreen3(data);
                return
            case 3: 
                handleSelectServiceDetailsNext(data);
                return
            case 6:
                if(!bookingObj?.updateReservationDetails) handleMakeReservation(data);
                else handleUpdateReservation(data);
                return
            case 4:
            case 5:
            default:
                setCurrentPage(currentPage+1);
                return
        }
    }

    const handleGoBack = () => {
        switch(currentPage){
            case 7:
                restartSpaBookingFlow()
                return
            default:
                if((currentPage <= 0) || (currentPage === 1 && bookingObj?.spa_data?.length == 1)){
                    dispatch(setGoHome(true));
                }
                setCurrentPage(currentPage-1);
                return
        }
    }

        

    useEffect(()=> {
        if (!isLoggedIn) {
            dispatch(setGoHome(true));
            dispatch(setShowLoginModal(true));
            return;
        }


        fetctSpaTreatmentList();

        dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, CLICKED, { element: "widget", "widgetSessionId": spaSessionToken}))
        
        return () => {
            const widgetCloseTime = new Date;
            const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
            dispatch(sendAnalytics(SPA_BOOKING_CATEGORY, EXIT, { element: "widget", duration: widgetCloseDuration, widgetSessionId: spaSessionToken }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <>
            {getCurrentPage()}


            {fetchApiError.errorStatus && 
                <InfoPopupModal
                    subtitle={fetchApiError.errorMessage} 
                    onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
                    primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
                    onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
                    secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
            />}


            {infoPopup.visible && 
                <InfoPopupModal
                    title={infoPopup?.title}
                    subtitle={infoPopup.subtitle} 
                    primaryBtnLabel={infoPopup.primaryBtnLabel ? infoPopup.primaryBtnLabel : "Close"} 
                    onContinue={infoPopup.onContinue ? infoPopup.onContinue : () => updateInfoPopup(false)}
                    onClose={infoPopup.onCloseFunc ? infoPopup.onCloseFunc : null}
                    secondaryBtnLabel={infoPopup.secondaryBtnLabel ? infoPopup.secondaryBtnLabel : null}
            />}

            {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
            {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}


        </>
    )
}

export default Book4Time;
